import { createRouter, createWebHistory } from 'vue-router';

// Komponenty PL
import LandingPagePL from '@/Pages/landing/index.vue';
import GalleryPagePL from "@/Pages/gallery/index.vue";
import ContactPagePL from "@/Pages/contact/index.vue";
import GalleryDetailPL from "@/Pages/galleryDetail/";

// Komponenty EN
import LandingPageEN from '@/Pages-en/landing/index.vue';
import GalleryPageEN from "@/Pages-en/gallery/index.vue";
import ContactPageEN from "@/Pages-en/contact/index.vue";
import GalleryDetailEN from "@/Pages-en/galleryDetail/";

const isEN = location.hostname.startsWith('en.');

const routes = isEN
    ? [
        {
            path: '/',
            name: 'LandingPageEN',
            component: LandingPageEN
        },
        {
            path: '/gallery',
            name: 'GalleryEN',
            component: GalleryPageEN
        },
        {
            path: '/contact',
            name: 'ContactEN',
            component: ContactPageEN
        },
        {
            path: '/gallery/:id',
            name: 'GalleryDetailEN',
            component: GalleryDetailEN
        }
    ]
    : [
        {
            path: '/',
            name: 'LandingPagePL',
            component: LandingPagePL
        },
        {
            path: '/galeria',
            name: 'GalleryPL',
            component: GalleryPagePL
        },
        {
            path: '/kontakt',
            name: 'ContactPL',
            component: ContactPagePL
        },
        {
            path: '/galeria/:id',
            name: 'GalleryDetailPL',
            component: GalleryDetailPL
        }
    ];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth'
            };
        } else if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    }
});

export default router;